<template>
	<BaseButton :size="size" :type="type" :colors="style" :grouped="grouped">
		<slot/>
	</BaseButton>
</template>
<script setup lang="ts">
import {Color} from '@/Types/Enums/Color'
import {ButtonType} from '@/Types/Enums/ButtonType'
import {ButtonSize} from '@/Types/Enums/ButtonSize'
import {computed, type ComputedRef, defineProps} from 'vue'
import BaseButton from '@/Components/UI/Buttons/BaseButton.vue'

const props = defineProps<{
	color:Color,
	type?:ButtonType,
	size?:ButtonSize,
	grouped?:boolean,
}>()

const style:ComputedRef<string> = computed(() => {
	const base:string = 'text-gray-500 bg-gray-100 border-gray-100 dark:bg-gray-900 dark:border-gray-900'
	switch(props.color){
		case Color.TrueAArEII:
			return `${base} hover:text-true-aareii-600 hover:bg-true-aareii-50 hover:border-true-aareii-50 dark:hover:text-true-aareii-400 dark:hover:bg-true-aareii-950 dark:hover:border-true-aareii-950`
		case Color.Red:
			return `${base} hover:text-red-600 hover:bg-red-50 hover:border-red-50 dark:hover:text-red-400 dark:hover:bg-red-950 dark:hover:border-red-950`
		case Color.Orange:
			return `${base} hover:text-orange-600 hover:bg-orange-50 hover:border-orange-50 dark:hover:text-orange-400 dark:hover:bg-orange-950 dark:hover:border-orange-950`
		case Color.Amber:
			return `${base} hover:text-amber-600 hover:bg-amber-50 hover:border-amber-50 dark:hover:text-amber-400 dark:hover:bg-amber-950 dark:hover:border-amber-950`
		case Color.Yellow:
			return `${base} hover:text-yellow-600 hover:bg-yellow-50 hover:border-yellow-50 dark:hover:text-yellow-400 dark:hover:bg-yellow-950 dark:hover:border-yellow-950`
		case Color.Lime:
			return `${base} hover:text-lime-600 hover:bg-lime-50 hover:border-lime-50 dark:hover:text-lime-400 dark:hover:bg-lime-950 dark:hover:border-lime-950`
		case Color.Green:
			return `${base} hover:text-green-600 hover:bg-green-50 hover:border-green-50 dark:hover:text-green-400 dark:hover:bg-green-950 dark:hover:border-green-950`
		case Color.Emerald:
			return `${base} hover:text-emerald-600 hover:bg-emerald-50 hover:border-emerald-50 dark:hover:text-emerald-400 dark:hover:bg-emerald-950 dark:hover:border-emerald-950`
		case Color.Teal:
			return `${base} hover:text-teal-600 hover:bg-teal-50 hover:border-teal-50 dark:hover:text-teal-400 dark:hover:bg-teal-950 dark:hover:border-teal-950`
		case Color.Cyan:
			return `${base} hover:text-cyan-600 hover:bg-cyan-50 hover:border-cyan-50 dark:hover:text-cyan-400 dark:hover:bg-cyan-950 dark:hover:border-cyan-950`
		case Color.Sky:
			return `${base} hover:text-sky-600 hover:bg-sky-50 hover:border-sky-50 dark:hover:text-sky-400 dark:hover:bg-sky-950 dark:hover:border-sky-950`
		case Color.Blue:
			return `${base} hover:text-blue-600 hover:bg-blue-50 hover:border-blue-50 dark:hover:text-blue-400 dark:hover:bg-blue-950 dark:hover:border-blue-950`
		case Color.Indigo:
			return `${base} hover:text-indigo-600 hover:bg-indigo-50 hover:border-indigo-50 dark:hover:text-indigo-400 dark:hover:bg-indigo-950 dark:hover:border-indigo-950`
		case Color.Violet:
			return `${base} hover:text-violet-600 hover:bg-violet-50 hover:border-violet-50 dark:hover:text-violet-400 dark:hover:bg-violet-950 dark:hover:border-violet-950`
		case Color.Purple:
			return `${base} hover:text-purple-600 hover:bg-purple-50 hover:border-purple-50 dark:hover:text-purple-400 dark:hover:bg-purple-950 dark:hover:border-purple-950`
		case Color.Fuchsia:
			return `${base} hover:text-fuchsia-600 hover:bg-fuchsia-50 hover:border-fuchsia-50 dark:hover:text-fuchsia-400 dark:hover:bg-fuchsia-950 dark:hover:border-fuchsia-950`
		case Color.Pink:
			return `${base} hover:text-pink-600 hover:bg-pink-50 hover:border-pink-50 dark:hover:text-pink-400 dark:hover:bg-pink-950 dark:hover:border-pink-950`
		case Color.Rose:
			return `${base} hover:text-rose-600 hover:bg-rose-50 hover:border-rose-50 dark:hover:text-rose-400 dark:hover:bg-rose-950 dark:hover:border-rose-950`
		case Color.Slate:
			return `${base} hover:text-slate-600 hover:bg-slate-50 hover:border-slate-50 dark:hover:text-slate-400 dark:hover:bg-slate-950 dark:hover:border-slate-950`
		case Color.Gray:
			return `${base} hover:text-gray-600 hover:bg-gray-50 hover:border-gray-50 dark:hover:text-gray-400 dark:hover:bg-gray-950 dark:hover:border-gray-950`
		case Color.Zinc:
			return `${base} hover:text-zinc-600 hover:bg-zinc-50 hover:border-zinc-50 dark:hover:text-zinc-400 dark:hover:bg-zinc-950 dark:hover:border-zinc-950`
		case Color.Stone:
			return `${base} hover:text-stone-600 hover:bg-stone-50 hover:border-stone-50 dark:hover:text-stone-400 dark:hover:bg-stone-950 dark:hover:border-stone-950`
		case Color.Neutral:
		default:
			return `${base} hover:text-neutral-600 hover:bg-neutral-50 hover:border-neutral-50 dark:hover:text-neutral-400 dark:hover:bg-neutral-950 dark:hover:border-neutral-950`
	}
})
</script>
